import { RootState } from '../../../../rootReducer';

export const boxTemplateSelector = (state: RootState) => state.templatesModuleReducer.BoxTemplateReducer;
